// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3Z32A","calendarButtons":"ClockData_calendarButtons__2QYH8"};